import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {Review} from "./review"

export const reviewLoader = function (options = {}) {
    componentLoader(componentConfig(Review, Review.config.componentTypeKey, Review.config.baseHtmlClass), options);
};

